import { render } from "./Step_BPPV_diagnosisView.vue?vue&type=template&id=52bcf5b4"
import script from "./Step_BPPV_diagnosisView.vue?vue&type=script&lang=js"
export * from "./Step_BPPV_diagnosisView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__